"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isItemsChanged = exports.addParamsToLink = exports.delay = exports.compareVersions = exports.checkOS = exports.checkBrowser = exports.escapeRegExp = exports.getPluralForm = exports.millisecondsToDays = exports.daysToMilliseconds = void 0;

exports.daysToMilliseconds = function (days) {
  return days * 24 * 60 * 60 * 1000;
};

exports.millisecondsToDays = function (ms) {
  return Math.floor(ms / 1000 / 60 / 60 / 24);
};

exports.getPluralForm = function (n, forms) {
  return n % 10 === 1 && n % 100 !== 11 ? forms[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? forms[1] : forms[2];
};

exports.escapeRegExp = function (s) {
  return s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};

exports.checkBrowser = function (currBowser, browsers) {
  return checkNameAndVersion(currBowser, browsers, 'version');
};

exports.checkOS = function (currBowser, operationSystems) {
  return checkNameAndVersion(currBowser, operationSystems, 'osversion');
};

var checkNameAndVersion = function checkNameAndVersion(currBowser, conditions, versionKey) {
  return conditions.some(function (nameConditionVersion) {
    var regex = /^([a-zA-Z]+)(=|!=|<|<=|>|>=)?(\d+)?$/;
    var arBrowser = regex.exec(nameConditionVersion);

    if (arBrowser === null) {
      return false;
    } else {
      var name_1 = arBrowser[1],
          condition = arBrowser[2],
          version = arBrowser[3];
      return (// @ts-ignore: IBowser has no index signature. Но нужно как то проверить что currBowser содержит информацию
        // об проверяемом браузере
        currBowser[name_1] !== undefined && checkVersion(+currBowser[versionKey], condition, +version)
      );
    }
  });
};

var checkVersion = function checkVersion(versionA, condition, versionB) {
  if (!versionB) {
    return true;
  }

  switch (condition) {
    case '=':
      return versionA === versionB;

    case '!=':
      return versionA !== versionB;

    case '<':
      return versionA < versionB;

    case '<=':
      return versionA <= versionB;

    case '>':
      return versionA > versionB;

    case '>=':
      return versionA >= versionB;

    default:
      return versionA === versionB;
  }
};
/**
 * отрефакторенная копия https://www.npmjs.com/package/compare-version + types
 * a > b => 1
 * a < b => -1
 * a = b => 0
 */


exports.compareVersions = function (ver1, ver2) {
  if (typeof ver1 + typeof ver2 !== 'stringstring') {
    return false;
  }

  var arVer1 = ver1.split('.');
  var arVer2 = ver2.split('.');
  var len = Math.max(arVer1.length, arVer2.length);

  for (var i = 0; i < len; i++) {
    if (arVer1[i] && !arVer2[i] && parseInt(arVer1[i], 10) > 0 || parseInt(arVer1[i], 10) > parseInt(arVer2[i], 10)) {
      return 1;
    } else if (arVer2[i] && !arVer1[i] && parseInt(arVer2[i], 10) > 0 || parseInt(arVer1[i], 10) < parseInt(arVer2[i], 10)) {
      return -1;
    }
  }

  return 0;
};

exports.delay = function (ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

exports.addParamsToLink = function (link, params) {
  var wholeParamsString = params.map(function (param) {
    if (param.value === undefined) {
      return param.name;
    }

    return param.name + "=" + encodeURIComponent(param.value);
  }).join('&');
  var delimiter = link.indexOf('?') === -1 ? '?' : '&';
  return "" + link + delimiter + wholeParamsString;
};
/**
 * Проверяем поменялся ли массив сертификатов.
 * @param ICertificateListItem[] oldItems
 * @param ICertificateListItem[] newItems
 */


exports.isItemsChanged = function (oldItems, newItems) {
  if (oldItems.length !== newItems.length) {
    return true;
  }

  for (var i = 0; i < oldItems.length; i++) {
    if (oldItems[i].certificate.thumbprint() !== newItems[i].certificate.thumbprint()) {
      return true;
    }
  }

  return false;
};